import { ScrapingStatus } from '../const';

const successStatuses: ScrapingStatus[] = [
  ScrapingStatus.SUCCESS,
  ScrapingStatus.SUCCESS_PARSING,
  ScrapingStatus.SUCCESS_KNOWLEDGE,
  ScrapingStatus.SUCCESS_DEMO,
];

export const SUCCESS_STATUS_SET = new Set<string>(successStatuses);

export const isSuccessStatus = (status?: string | null): boolean => {
  if (!status) {
    return false;
  }

  return SUCCESS_STATUS_SET.has(status.toUpperCase());
};

const deletableStatuses: ScrapingStatus[] = [
  ScrapingStatus.SUCCESS,
  ScrapingStatus.SUCCESS_PARSING,
  ScrapingStatus.SUCCESS_KNOWLEDGE,
  ScrapingStatus.SUCCESS_DEMO,
  ScrapingStatus.FAILURE,
  ScrapingStatus.FAILURE_PARSING,
  ScrapingStatus.FAILURE_KNOWLEDGE,
  ScrapingStatus.FAILURE_DEMO,
  ScrapingStatus.REVOKED,
];

export const DELETABLE_STATUS_SET = new Set<string>(deletableStatuses);

export const isDeletableStatus = (status?: string | null): boolean => {
  if (!status) {
    return false;
  }

  return DELETABLE_STATUS_SET.has(status.toUpperCase());
};

export const isSuccessDemoStatus = (status?: string | null): boolean => {
  if (!status) {
    return false;
  }

  return status.toUpperCase() === ScrapingStatus.SUCCESS_DEMO;
};
